import { render, staticRenderFns } from "./IcoDashboard.vue?vue&type=template&id=e675a8be"
import script from "./IcoDashboard.vue?vue&type=script&lang=js"
export * from "./IcoDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports